<template>
  <div
    class="relative flex items-center pr-4 transition-colors duration-[1200ms] even:bg-neutral-50"
    :class="flashing ? '!bg-green-100' : ''"
  >
    <img
      v-if="upsell.product?.featured_image"
      :src="upsell.product.featured_image"
      alt="Protein Pack"
      class="w-24 h-24 object-contain"
      width="200"
      height="200"
    >
    <div class="font-semibold w-full pr-2 flex flex-col gap-1">
      <div class="flex items-center gap-2 flex-wrap">
        <span>Protein Pack – {{ upsell.stagedAtSize }} Packs</span>
        <span class="text-xs font-medium leading-5 px-2.5 py-0.5 rounded-full bg-green-100 text-green-600">
          {{ upsell.isCartItemSub ? 'Subscription' : 'One-Time' }}
        </span>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-green-500 font-medium">+{{ formatCents(upsell.stagedVariant?.price ?? 0) }}</span>
        <button
          class="text text-neutral-500 text-sm font-medium"
          :disabled="upsell.loading"
          @click="upsell.remove()"
        >
          Remove
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useProteinPackUpsellStore } from '@/stores'
import { formatCents } from '@/utils/formatters'

const upsell = useProteinPackUpsellStore()

const flashing = ref(true)
onMounted(() => {
  setTimeout(() => {
    flashing.value = false
  }, 800)
})
</script>
